export const LOGS_CONST = {
  DEFAULT_ADVANCED_QUERY: 'SELECT document, source, time as timestamp FROM rawlogs LIMIT 100',
  TABLE_PAGE_SIZE: 25,
  EXTERNAL_PROJECTION_TABLE: 'rawlogs',
  EXTERNAL_PROJECTION_TABLE_LH: 'all_logs',
  VIEW_PROJECTION_TIMESTAMP_NAME: 'event_timestamp',
  EXTERNAL_PROJECTION_TIMESTAMP_NAME: 'time',
} as const;
